<template>
  <div class="the-navbar__user-meta flex items-center" >
      <div class="con-img ml-3">
        <img v-if="collegeLogo || companylogo" key="onlineImg" @click="profile(college)" :src="logo" alt="user-img" width="40" height="40" class="rounded-full shadow-md cursor-pointer block" />
      </div>
      <div class="text-right leading-tight hidden sm:block">
      <p class="font-medium ml-2">{{ college.CollegeName || company.CompanyName }}</p>
        </div>
    </div>
</template>
<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import "firebase/firestore"
export default {
    props:{
        studentcode:{
            type:String,
            required:true
        }
    },
    data(){
        return{
            logo:'',
            company:[],
            college:[]
        }
    },
    methods:{
        profile(col){
            //console.log(col)
            if(this.$acl.get[0] === 'admin'){
                this.$router.push('/dashboard/collegeProfile')
            }
            if(this.$acl.get[0] === 'editor'){
                this.$router.push('/dashboard/Your-College-Details')
            }
        }
    },
computed:{
    collegeLogo(){
            const user=firebase.auth().currentUser
            const thisIns =this
            if(thisIns.$acl.get[0]==='editor'){
             firebase.firestore().collection("CollegeCode").where("StudentCode", "==" ,thisIns.studentcode).get().then(function(querySnapshot) {
        querySnapshot.forEach(function(doc) {
            var img1 = doc.data().logo
            thisIns.logo =img1
            //console.log(thisIns.logo)
            thisIns.college = doc.data()
                
        })
             })
            }
             if(thisIns.$acl.get[0]==='admin'){
             firebase.firestore().collection("CollegeCode").where("StudentCode", "==" ,thisIns.studentcode).get().then(function(querySnapshot) {
        querySnapshot.forEach(function(doc) {
            var img1 = doc.data().logo
            thisIns.logo =img1
            //console.log(thisIns.logo)
            thisIns.college = doc.data()
                
        })
             })
            }
          return thisIns.logo
        },
        companylogo(){
            const user=firebase.auth().currentUser
            const thisIns =this
            let RecruiterCode=''
            if(thisIns.$acl.get[0]==='post'){
                firebase.firestore().collection('RecruiterId').doc(user.uid).get().then(doc=>{
                     RecruiterCode= doc.data().RecruiterCode
                   // console.log(RecruiterCode)
                    
                }).then(()=>{
                    firebase.firestore().collection('RecruiterCode').doc(RecruiterCode).get().then(doc=>{
                        thisIns.logo= doc.data().logo
                        thisIns.company.CompanyName= doc.data().CompanyName
                    })
                })
       
           /*  firebase.firestore().collection("RecruiterCode").doc(user.uid).collection("CompanyDetails").doc(user.uid).get().then(function(doc) {
        if(doc.exists)
            var img1 = doc.data().logo
            thisIns.logo =img1
            //console.log(thisIns.logo)
            thisIns.company = doc.data()
            
                
        
             })
             */
            }
        
          return this.logo
        },
      
} 
}
</script>